import $ from 'jquery';

$(() => {

	if ($('.clients-grid').length === 0) return;

	if (window.innerWidth < 768) {
		$('.clients-grid__logos').scrollLeft(150);
	}

});